import * as React from 'react';
import { namespacedClassnames } from '../../common';
// tslint:disable-next-line: max-line-length
import { DeprecatedPositiveButton, DeprecatedAttentionButton, DeprecatedDangerButton, DeprecatedSpecialButton } from '../../primitives/deprecated-buttons/deprecated-button/button';
var compToType = function (fn) {
    // tslint:disable-next-line:switch-default
    switch (fn) {
        case DeprecatedPositiveButton:
            return 'positive';
        case DeprecatedAttentionButton:
            return 'attention';
        case DeprecatedDangerButton:
            return 'danger';
        case DeprecatedSpecialButton:
            return 'special';
        default:
            return 'default';
    }
};
var key = 'button-group';
export var ButtonGroup = function (props) {
    // tslint:disable-next-line:only-arrow-functions
    // tslint:disable-next-line:max-line-length
    var types = React.Children.toArray(props.children).map(function (c) {
        return compToType(c && c.type);
    }) || [];
    types.sort();
    if (types && types[0] !== types[types.length - 1]) {
        console.warn('DeprecatedButton group should be used only with one type of button inside it');
    }
    var type = types[0];
    var classNames = namespacedClassnames(key, props.className, type || 'default');
    // tslint:disable-next-line:no-console
    return (React.createElement("div", { className: classNames }, props.children));
};
//# sourceMappingURL=button-group.js.map